/**
 * This file contains the options for base styles in frankly specific utility classes in app/styles/frn-base.css
 * These options can be used by components with properties that needs stylesheet color, size, opacity or font weight, etc
 */

const GUTTER_STYLE = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

const INSET_STYLE = {
  xxs: 'xxs',
  ...GUTTER_STYLE,
  xl: 'xl'
};

const INSET_STYLE_VALUE_MAPPING = {
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 32,
  xl: 64
};

const SIZE_STYLE = {
  ...INSET_STYLE,
  xxl: 'xxl',
  xxxl: 'xxxl'
};

const COLOR_STYLE = {
  chrome: 'chrome',
  accent: 'accent',
  attention: 'attention'
};

const OPACITY_STYLE = {
  strong: 'strong',
  medium: 'medium',
  mild: 'mild',
  weak: 'weak',
  slight: 'slight'
};

const FONT_WEIGHT_STYLE = {
  light: 'light',
  regular: 'regular',
  semibold: 'semibold',
  bold: 'bold'
};

const TITLE_TYPE = {
  PAGE_TITLE: 'Page Title',
  MODULE_TITLE: 'Module Title'
};

const GRID_SYSTEM = {
  overflow: {
      text: 7,
      submitForm: 5 
  },
  basic: {
      text: 4,
      submitForm: 8
  }
};

const BREAKPOINTS = [
  {size: 'xs', minWidth: 0},
  {size: 'sm', minWidth: 768},
  {size: 'md', minWidth: 992},
  {size: 'lg', minWidth: 1200},
  {size: 'xl', minWidth: 1470}
];

export { GUTTER_STYLE, INSET_STYLE, SIZE_STYLE, COLOR_STYLE, OPACITY_STYLE, FONT_WEIGHT_STYLE, INSET_STYLE_VALUE_MAPPING, TITLE_TYPE, GRID_SYSTEM, BREAKPOINTS };



// WEBPACK FOOTER //
// ./app/constants/FRNBaseStyles.js